module.exports = __webpack_public_path__ + "static/media/banner_home_happyhour.64a8bee2.jpg";